// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"23447c04","484":"d871f429","551":"713b402d","629":"97959b7e","869":"3fecef22","974":"a5641ba3"}[chunkId] + ".chunk.js";
};